<template lang="pug">
header(v-on-away="away")
  .navbar-container
    nav.navbar
      .navbar-brand
        router-link.navbar-item(:to="`/${getLanguage}/`")
          img(src="@/assets/images/logo-bixter.png" alt="bixter-logo" @click="showNav = false")

        .wrap-burger
          .burger-title.is-hidden-desktop.is-hidden-mobile(@click="showNav = !showNav") {{ gettext('Menu') }}
          .navbar-burger(@click="showNav = !showNav" :class="{ 'is-active': showNav }")
            span(aria-hidden="true")
            span.red(aria-hidden="true")
            span(aria-hidden="true")
      .navbar-menu(:class="{ 'is-active': showNav }")
        .navbar-left
          .navbar-btns
            router-link.main-btn.col-white.bg-red.nav-item.is-tab.width-auto(:to="`/${getLanguage}/registration#employer`" v-if="!$auth.check()")
              span(@click="showNav = false") {{ gettext('Post a job') }}
            router-link.main-btn.col-white.bg-red.nav-item.is-tab.post-job-btn(:to="{name: 'CreateJob', params:{lang: getLanguage}}" v-if="($auth.check() && getUser.profile_type === CONSTANTS.EMPLOYER_PROFILE_TYPE || $auth.check() && getUser.profile_type === CONSTANTS.RECEIVER_PROFILE_TYPE)")
              span(@click="showNav = false") {{ gettext('Post a job') }}
            router-link.main-btn.col-white.bg-black.nav-item.is-tab.width-auto(:to="`/${getLanguage}/registration`" v-if="!$auth.check()")
              span(@click="showNav = false") {{ gettext('Create a CV') }}
            router-link.main-btn.col-white.bg-black.nav-item.is-tab.width-auto(:to="{name: 'CreateCV', params:{lang: getLanguage}}" v-if="($auth.check() && getUser.profile_type === CONSTANTS.JOBSEEKER_PROFILE_TYPE || $auth.check() && getUser.profile_type === CONSTANTS.SENDER_PROFILE_TYPE)")
              span(@click="showNav = false") {{ gettext('Create a CV') }}
          .navbar-links
            .nav-item-wrap
              a.nav-item.is-tab(href="https://www.bixter.training" target="_blanc")
                span(@click="showNav = false") {{ gettext('Trainees') }}
            .nav-item-wrap(v-if="false")
              router-link.nav-item.is-tab(:to="{name: 'HospitalityTrainee', params:{lang: getLanguage}}")
                span(@click="showNav = false") {{ gettext('Hospitality trainees') }}
            router-link.nav-item.is-tab(:to="{name: 'Workers', params:{lang: getLanguage}}")
              span(@click="showNav = false") {{ gettext('CV`s') }}
            router-link.nav-item.is-tab(:to="{name: 'FindJob', params:{lang: getLanguage}}")
              span(@click="showNav = false") {{ gettext('Jobs') }}
            router-link.nav-item.is-tab(:to="`/${getLanguage}/contacts`")
              span(@click="showNav = false") {{ gettext('Contact us') }}
        .navbar-end
          router-link.main-btn.col-white.bg-red.nav-item.is-tab(:to="{name: 'CreateCV', params:{lang: getLanguage}}" v-if="($auth.check() && getUser.profile_type === CONSTANTS.JOBSEEKER_PROFILE_TYPE && !getCVStatus )")
            span(@click="showNav = false") {{ gettext('Create CV') }}
          router-link.main-btn.col-white.bg-red.nav-item.is-tab(:to="{name: 'MyCVS', params:{lang: getLanguage}}" v-if="($auth.check() && getUser.profile_type === CONSTANTS.JOBSEEKER_PROFILE_TYPE && getCVStatus )")
            span(@click="showNav = false") {{ gettext('My CV`s') }}
          router-link.main-btn.col-white.bg-red.nav-item.is-tab(
          :to="{name: 'Dashboard', params:{lang: getLanguage}}"
          v-if="($auth.check() && (getUser.profile_type === CONSTANTS.SENDER_PROFILE_TYPE || getUser.profile_type === CONSTANTS.RECEIVER_PROFILE_TYPE) )")
            span(@click="showNav = false") {{ gettext('Dashboard') }}
          router-link.gray(:to="{name: 'Login', params: {lang: getLanguage}, query: {redirect: $route.fullPath}}" v-if="!$auth.check() && $route.name != 'Login'")
            span(@click="showNav = false") {{ gettext('Log in') }}
          router-link.gray(:to="`/${getLanguage}/registration`" v-if="!$auth.check() && $route.name === 'Login'")
            span(@click="showNav = false") {{ gettext('Register') }}
          .dropdown.profile-popup(:class="{'show': !hideMenu}" @click="hidePopup" @mouseout="hideMenu = true" v-if="$auth.check()")

            .dropdown-trigger(@mouseover="hideMenu = false" v-if="!isFixHeader")
              router-link.main-btn.profile.small(:to="`/${getLanguage}/profile`")
                .mdi.mdi-account.mdi-48px(v-if="!avatar")
                .profile-avatar(v-else :style="{'background-image': 'url(' + avatar + ')'}")
            .dropdown-trigger(v-else)
              div.main-btn.profile.small
                .mdi.mdi-account.mdi-48px(v-if="!avatar")
                .profile-avatar(v-else :style="{'background-image': 'url(' + avatar + ')'}")

            .dropdown-menu#profile-menu(@mouseover="!isFixHeader ? hideMenu = false : false" )
              .dropdown-content
                .list
                  span(@click="hideMenu = false") +
                  router-link.field.is-horizontal(:to="`/${getLanguage}/profile`" v-if="$auth.check()")
                    span(@click="showNav = false") {{ gettext('Profile') }}
                  router-link.field.is-horizontal(:to="{name: 'MyCVS', params: {lang: getLanguage}}" v-if="getUser.profile_type === CONSTANTS.JOBSEEKER_PROFILE_TYPE")
                    span(@click="showNav = false") {{ gettext('My CV`s') }}
                  router-link.field.is-horizontal(:to="{name: 'MyJobs', params: {lang: getLanguage}}" v-if="getUser.profile_type === CONSTANTS.EMPLOYER_PROFILE_TYPE")
                    span(@click="showNav = false") {{ gettext('List of jobs') }}
                  router-link.field.is-horizontal(
                  :to="{name: 'Dashboard', params:{lang: getLanguage}}"
                  v-if="getUser.profile_type === CONSTANTS.SENDER_PROFILE_TYPE || getUser.profile_type === CONSTANTS.RECEIVER_PROFILE_TYPE"
                  )
                    span(@click="showNav = false") {{ gettext('Dashboard') }}
                  router-link.field.is-horizontal(
                  :to="{name: 'Cabinet', params: {lang: getLanguage}}"
                  v-if="[CONSTANTS.EMPLOYER_PROFILE_TYPE, CONSTANTS.RECEIVER_PROFILE_TYPE].indexOf(getUser.profile_type) !== -1"
                  )
                    span(@click="showNav = false") {{ gettext('List of invoices') }}
                  router-link.field.is-horizontal(
                  :to="{name: 'BoughtServices', params: {lang: getLanguage}}"
                  v-if="[CONSTANTS.EMPLOYER_PROFILE_TYPE, CONSTANTS.RECEIVER_PROFILE_TYPE].indexOf(getUser.profile_type) !== -1"
                  )
                    span(@click="showNav = false") {{ gettext('Bought services') }}
                  router-link.field.is-horizontal(:to="{name: 'Favorites', params: {lang: getLanguage}}")
                    span(@click="showNav = false") {{ gettext('Wish list') }}
                  .field.is-horizontal.linned-bottom
                    label.label.name
                    .field-body
                    label.label.edit
                  .field.is-horizontal(@click="exit")
                    span(@click="showNav = false") {{ gettext('Logout') }}
          language-selector(
          v-if="$lang.getSupportedLanguages()"
          :items="languageList"
          :current="getLanguage"
          @selected="changeLanguage($event)"
          )

</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import { gettext } from '@/services/TranslateHandler'
import { directive as onAway } from 'vue-clickaway'
import LanguageSelector from '@/components/language-selector'

const CONSTANTS = require('@/constants.json')

export default {
  components: {
    LanguageSelector
  },
  data () {
    return {
      languageList: [],
      showNav: false,
      CONSTANTS: CONSTANTS,
      hideMenu: true,
      isFixHeader: false,
      selectedLang: 'en',
      howWorksLinks: {
        en: 'http://bixter.com/how-it-works-en/',
        da: 'http://bixter.com/how-it-works-dk/',
        de: 'http://bixter.com/how-it-works-de/',
        ru: 'http://bixter.com/how-it-works-ru/',
        uk: 'http://bixter.com/how-it-works-ua/',
        ro: 'http://bixter.com/how-it-works-ro/'
      }
    }
  },
  directives: {
    onAway
  },
  mounted () {
    this.getLanguageList()
  },
  methods: {
    gettext: gettext,
    ...mapActions([
      'logout',
      'languageRedirect',
      'receiveSupportedLanguages',
      'receiveTranslate',
      'setLanguage'
    ]),
    changeLanguage (lang) {
      this.showNav = false
      this.receiveTranslate(lang.code).then(() => {
        this.setLanguage(lang.code)
        this.languageRedirect(lang.code)
      })
    },
    getLanguageList () {
      this.receiveSupportedLanguages().then(res => {
        this.languageList = res
      })
    },
    away () {
      this.showNav = false
    },
    exit () {
      this.logout()
    },
    hidePopup () {
      this.hideMenu = !this.hideMenu
    }
  },
  created () {
    let r = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth
    window.onresize = () => {
      let r = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth
      this.$nextTick(() => {
        this.isFixHeader = (r <= 1087)
      })
    }
    if (r <= 1087) this.isFixHeader = true
  },
  computed: {
    ...mapGetters([
      'getLanguage',
      'getUser',
      'getCVStatus'
    ]),
    avatar: function () {
      return (this.getUser.avatar_urls || {}).min || (this.getUser.companylogo_urls || {}).sq_min || (this.getUser.companylogo_urls || {}).min
    }
  },
  filters: {
    toLower: function (value) {
      return value.toLowerCase()
    }
  }
}
</script>

<style scoped lang="scss" src="./styles.scss"></style>



// WEBPACK FOOTER //
// src/parts/header/index.vue